module.exports = __webpack_public_path__ + "static/custom-labels-on-nav-item-b2ad9a4357e33bcd2ea4e9246a613f10.png";